"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asechDocs = void 0;
var asechDocs = exports.asechDocs = {
  name: 'asech',
  category: 'Trigonometry',
  syntax: ['asech(x)'],
  description: 'Calculate the inverse secant of a value.',
  examples: ['asech(0.5)'],
  seealso: ['acsch', 'acoth']
};